export default [

  // PURCHASE
  {
    path: '/toko/purchase/list',
    name: 'toko-purchase-list',
    component: () => import('@/views/toko/purchase/purchase-list/PurchaseList.vue'),
    meta: {
      pageTitle: 'Pembelian',
      breadcrumb: [
        {
          text: 'Pembelian',
          active: true,
        },
      ],
      resource: 'toko-purchase-list',
      action: 'read',
    },
  },
  {
    path: '/toko/purchase/add',
    name: 'toko-purchase-add',
    component: () => import('@/views/toko/purchase/purchase-add/PurchaseAddNew.vue'),
    meta: {
      pageTitle: 'Pembelian',
      breadcrumb: [
        {
          text: 'Pembelian',
          to: { name: 'toko-purchase-list' },
        },
        {
          text: 'Tambah',
          active: true,
        },
      ],
      resource: 'toko-purchase-list',
      action: 'read',
    },
  },
  {
    path: '/toko/purchase/preview/:id',
    name: 'toko-purchase-preview',
    component: () => import('@/views/toko/purchase/purchase-preview/PurchasePreview.vue'),
    meta: {
      pageTitle: 'Pembelian',
      breadcrumb: [
        {
          text: 'Pembelian',
          to: { name: 'toko-purchase-list' },
        },
        {
          text: 'Lihat',
          active: true,
        },
      ],
      resource: 'toko-purchase-list',
      action: 'read',
    },
  },

  // CASHIER
  {
    path: '/toko/cashier/add',
    name: 'toko-cashier-add',
    component: () => import('@/views/toko/sales/sales-add/SalesAddNew.vue'),
    meta: {
      pageTitle: 'Kasir',
      breadcrumb: [
        {
          text: 'Kasir',
        },
      ],
      public: true,
    },
  },
  {
    path: '/toko/cashier/add',
    name: 'toko-cashier-presales-add',
    component: () => import('@/views/toko/sales/sales-add/SalesAddNew.vue'),
    meta: {
      pageTitle: 'Kasir',
      breadcrumb: [
        {
          text: 'Kasir',
        },
      ],
      public: true,
    },
  },
  {
    path: '/toko/cashier/presales/:id',
    name: 'toko-cashier-presales',
    component: () => import('@/views/toko/sales/sales-add/PreSalesAddNew.vue'),
    meta: {
      pageTitle: 'Kasir',
      breadcrumb: [
        {
          text: 'Penjualan',
          to: { name: 'toko-sales-list' },
        },
        {
          text: 'Gunakan Pesanan',
          active: true,
        },
      ],
      public: true,
    },
  },

  // PRESALES
  {
    path: '/toko/presales/list',
    name: 'toko-presales-list',
    component: () => import('@/views/toko/sales/sales-list/PreSalesList.vue'),
    meta: {
      pageTitle: 'Pesanan',
      breadcrumb: [
        {
          text: 'Pesanan',
          to: { name: 'toko-presales-list' },
          active: true,
        },
      ],
      resource: 'toko-presales-list',
      action: 'read',
    },
  },

  {
    path: '/toko/presales/preview/:id',
    name: 'toko-presales-preview',
    component: () => import('@/views/toko/sales/sales-preview/PreSalesPreview.vue'),
    meta: {
      pageTitle: 'Pesanan',
      breadcrumb: [
        {
          text: 'Pesanan',
          to: { name: 'toko-presales-list' },
        },
        {
          text: 'Lihat Pesanan',
          to: { name: 'toko-presales-preview' },
          active: true,
        },
      ],
      resource: 'toko-presales-list',
      action: 'read',
    },
  },

  // SALES
  {
    path: '/toko/sales/list',
    name: 'toko-sales-list',
    component: () => import('@/views/toko/sales/sales-list/SalesList.vue'),
    meta: {
      pageTitle: 'Penjualan',
      breadcrumb: [
        {
          text: 'Penjualan',
          to: { name: 'toko-sales-list' },
          active: true,
        },
      ],
      resource: 'toko-sales-list',
      action: 'read',
    },
  },
  {
    path: '/toko/sales/edit/:id',
    name: 'toko-sales-edit',
    component: () => import('@/views/toko/sales/sales-edit/SalesEditNew.vue'),
    meta: {
      pageTitle: 'Penjualan',
      breadcrumb: [
        {
          text: 'Penjualan',
          to: { name: 'toko-sales-list' },
        },
        {
          text: 'Ubah Penjualan',
          to: { name: 'toko-sales-edit' },
          active: true,
        },
      ],
      resource: 'toko-sales-list',
      action: 'read',
    },
  },
  {
    path: '/toko/sales/preview/:id',
    name: 'toko-sales-preview',
    component: () => import('@/views/toko/sales/sales-preview/SalesPreview.vue'),
    meta: {
      pageTitle: 'Penjualan',
      breadcrumb: [
        {
          text: 'Penjualan',
          to: { name: 'toko-sales-list' },
        },
        {
          text: 'Cetak Penjualan',
          to: { name: 'toko-sales-view' },
          active: true,
        },
      ],
      resource: 'toko-sales-list',
      action: 'read',
    },
  },

  // PITUANG PELANGGAN
  {
    path: '/master-data/customer/list',
    name: 'master-customer-bill',
    component: () => import('@/views/master-data/customer/customer-list/CustomerBill.vue'),
    meta: {
      pageTitle: 'Piutang Pelanggan',
      breadcrumb: [
        {
          text: 'Piutang Pelanggan',
          to: { name: 'master-customer-bill' },
          active: true,
        },
      ],
      resource: 'master-customer-bill',
      action: 'read',
    },
  },
]
